// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// ** Axios Imports
import API from "../../../../utility/custom/API";
import { toast } from "react-toastify";

import { getQuizUsers } from "../../fm-quiz/store";

export const getData = createAsyncThunk('appMovie/getData', async params => {
  let response = ''
  if (params.q.length > 0) {
     response = await API.get(`items/getAll?page=${params.page}&keyword=${params.q}`)
     
  } else {
     response = await API.get(`items/getAll?page=${params.page}`)
  }
  return {
    data: response.data,
    allData: response.data,
    totalPages: response.total,
    params
  
  }
})


export const getSubItems = createAsyncThunk('appMovie/getSubItems', async paramsSubItems => {
  const dataInfo = new FormData()
  dataInfo.append("id", paramsSubItems.id)
  const response = await API.get(`items/getSubItem?id=${paramsSubItems.id}`)
  const newDataWithId = response.data.map(movie => {
    return {
      ...movie,_id:paramsSubItems.id
    }
  })
  return {
    dataSubItems: newDataWithId,
    allDataSubItems: newDataWithId,
    totalPagesSubItems: response.total,
    paramsSubItems
  }
})

export const getCountryIds = createAsyncThunk('appMovie/getCountryIds', async () => {
  const response = await API.get('/countries')
  
  return {
    countryIds: response
  }
})
export const getVoicesAndSubtitles = createAsyncThunk('appMovie/getVoicesAndSubtitles', async () => {
  const response = await API.get('/voicesAndSubtitles')
  return {
    voicesAndSubtitles: response
  }
})
export const getCategories = createAsyncThunk('appMovie/getCategories', async () => {
  const response = await API.get('/categories')
  return {
    categories: response
  }
})
export const getQuestions = createAsyncThunk('appMovie/getQuestions', async () => {
  const response = await API.get('questions/get')
  return {
    questions: response
  }
})
export const getAnswers = createAsyncThunk('appMovie/getAnswers', async () => {
  const response = await API.get('items/getAllAnswers')
  return {
    answers: response
  }
})
export const getArtists = createAsyncThunk('appMovie/getArtists', async () => {
  const response = await API.get('/filmCasts')
  
  return {
    artists: response.data
  }
})

export const getCurrentId = createAsyncThunk('appMovie/getCurrentId', async (id, { dispatch, getState }) => {
  return {
    currentId: id,
  }
})
export const deleteMovie = createAsyncThunk('appMovie/deleteMovie', async (id, { dispatch, getState }) => {
  const dataInfo = new FormData()
  dataInfo.append("id", id)
  dataInfo.append("_method", 'delete')
  await API.post(`/items`, dataInfo )
  toast.success("با موفقیت عملیات انجام شد")
  getCurrentId(null)
  
  await dispatch(getData(getState().movie.params))
  return id
})

export const appMovieSlice = createSlice({
  name: 'appMovie',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    artists: [],
    countryIds: [],
    questions: [],
    categories: [],
    voicesAndSubtitles:[],
    answers:[],
    dataSubItems: [],
    totalPagesSubItems: 1,
    allDataSubItems: [],
    paramsSubItems: {},
    currentId:null,
  
  
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
        
           .addCase(getVoicesAndSubtitles.fulfilled, (state, action) => {
             state.voicesAndSubtitles = action.payload.voicesAndSubtitles
           })
           .addCase(getCountryIds.fulfilled, (state, action) => {
             state.countryIds = action.payload.countryIds
           })
           .addCase(getCategories.fulfilled, (state, action) => {
             state.categories = action.payload.categories
           })
           .addCase(getQuestions.fulfilled, (state, action) => {
             state.questions = action.payload.questions
           }).addCase(getAnswers.fulfilled, (state, action) => {
             state.answers = action.payload.answers
           })
           .addCase(getArtists.fulfilled, (state, action) => {
             state.artists = action.payload.artists
           })
           .addCase(getSubItems.fulfilled, (state, action) => {
             state.dataSubItems = action.payload.dataSubItems
             state.allDataSubItems = action.payload.allDataSubItems
             state.totalPagesSubItems = action.payload.totalPagesSubItems
             state.paramsSubItems = action.payload.paramsSubItems
           }).addCase(getCurrentId.fulfilled, (state, action) => {
      state.currentId = action.payload.currentId
  
    })
  }
})

export default appMovieSlice.reducer
